export default __webpack_public_path__ + "b2c2051d6098e38721efe1e62b4be1f3.woff2";